import React from 'react'
import styled from "styled-components";
import { HOME, ONE_KB_INITIATIVE } from '../../../routes/paths.routes';




export default function InternalLinks() {

  const links = [
    {
      id: 1,
      url: HOME,
      text: "Home"
    },
    {
      id: 2,
      url: `${ONE_KB_INITIATIVE}/#about`,
      text: "About Eratek1KB"
    },
    {
      id: 3,
      url: `${ONE_KB_INITIATIVE}/#benefits`,
      text: "Benefits of Eratek1KB"
    },
    {
      id: 4,
      url: `${ONE_KB_INITIATIVE}/#faqs`,
      text: "FAQs"
    },
  ];



  return (
    <div
      data-aos="fade-up"
      className="footer-col"
      data-aos-once="true"
    >
      <Text>
        Links
      </Text>

      <LinksWrapper>
        {
          links.map((link) => {
            return (
              <Link
                key={link.id}
              >
                <a
                  href={link.url}
                  className="link"
                >
                  {link.text}
                </a>
              </Link>
            )
          })
        }
      </LinksWrapper>
    </div>
  )
};



const Text = styled.div`
  font-family: Nunito;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
  margin-bottom: 1rem;
  color: var(--white-color);
`;

const LinksWrapper = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0;
  row-gap: 1rem;
`;

const Link = styled.li`
  list-style-type: none;
  display: inline-block;
  width: 100%;
`;